<template>
  <tr>
    <td>{{ label.nameTh || '-' }}</td>
    <td>{{ label.nameEn || '-' }}</td>
    <td>{{ label.selectedPackageCount }}</td>
    <td>
      <el-button size="small" type="edit" icon="el-icon-edit" @click="$emit('edit', label)">
        แก้ไข
      </el-button>
      <el-button size="small" type="delete" icon="el-icon-delete" @click="$emit('delete', label)">
        ลบ
      </el-button>
    </td>
  </tr>
</template>

<script lang="js">

export default {
  props: {
    label: {
      type: Object,
      required: true,
      validator(label) {
        return label && typeof label.id === 'number' &&
          typeof label.nameTh === 'string' &&
          typeof label.nameEn === 'string' &&
          typeof label.selectedPackageCount === 'number'
      }
    }
  }
}

</script>

<style scoped>
.el-button+.el-button {
  margin-left: var(--size-sm);
}

/* Table cell styling - consistent across all screen sizes */
tr td {
  border-bottom: 1px solid #f3f4f6 !important;
  font-size: 14px !important;
  color: #374151 !important;
  vertical-align: middle !important;
  padding: 16px !important;
}

tr td:nth-child(3) {
  text-align: center !important;
  font-weight: 600 !important;
  color: #1f2937 !important;
}

tr td:nth-child(4) {
  text-align: center !important;
  padding: 16px !important;
}

/* Modern button styling */
.el-button {
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  background: transparent;
  transition: all 0.3s ease;
}

.el-button.el-button--edit {
  color: #00b4d8;
}

.el-button.el-button--edit:hover {
  background-color: rgba(0, 180, 216, 0.1);
}

.el-button.el-button--delete {
  color: #e63946;
}

.el-button.el-button--delete:hover {
  background-color: rgba(230, 57, 70, 0.1);
}
</style>
